import type { FC } from "react";

import { ECategoryReferralsType } from "app/pages/website-analysis/website-structure/pages/ReferralsWrapper";
import { WWOTopReferringIndustriesTable } from "app/pages/website-performance/components/TopReferringIndustries/WWOTopReferringIndustriesTable";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const WWOTopReferringIndustriesContainerDS: FC = () => {
    const params = proNavigator.getParams();
    const getCtaLink = () => {
        return {
            href: proNavigator.href("digitalsuite_website_referrals_incomingtraffic", {
                ...params,
                selectedTab: ECategoryReferralsType.IncomingTraffic,
            }),
            target: "_self",
        };
    };
    return (
        <WWOTopReferringIndustriesTable
            getCtaLink={getCtaLink}
            unlockHook={{
                component: "WebReferralIncomingTraffic",
                hookModal: "referrals",
            }}
        />
    );
};
